// import { Backdrop, Button, CircularProgress } from "@mui/material";
// import React, { useEffect } from "react";
// import store, { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { paymentSuccess } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useLocation, useNavigate } from "react-router-dom";

// const PaymentSuccessHandler = () => {
//     const dispatch = useAppDispatch();
//     const location = useLocation();
//     const { orders } = useAppSelector(store => store)
//     const navigate=useNavigate();

//     const getQueryParam = (key: string): string | null => {
//         const params = new URLSearchParams(location.search);
//         return params.get(key);
//     };
//     const paymentId = getQueryParam("razorpay_payment_id");
//     const paymentLinkId = getQueryParam("razorpay_payment_link_id");
//     // const paymentId="cs_test_a1eU8pFuXZJlg3tiahN153QykvQl6LI5hLgSnUUh01alidIPrMU8KyDx67"

//     useEffect(() => {
//         if (paymentId) {
//             dispatch(
//                 paymentSuccess({
//                     paymentId,
//                     paymentLinkId: paymentLinkId || "",
//                     jwt: localStorage.getItem("jwt") || "",
//                 })
//             );
//         }
//     }, [paymentId]);


//     return (
//         <div className="min-h-[90vh] flex justify-center items-center">
//             {orders ? <div className="bg-primary-color text-white p-8 w-[90%] lg:w-[25%] border rounded-md h-[40vh] flex flex-col gap-7 items-center justify-center">
//                 <h1 className="text-3xl font-semibold">Congratulations!</h1>
//                 <h1 className="text-2xl font-semibold">Your Order Get Success</h1>
//                 <div>
//                     <Button onClick={()=>navigate("/")} color="secondary" variant="contained">Shopping More</Button>
//                 </div>

//             </div> : <Backdrop
//                 sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//                 open={true}
//             //   onClick={handleClose}
//             >
//                 <CircularProgress color="inherit" />
//             </Backdrop>}
           
//         </div>
//     );
// };

// export default PaymentSuccessHandler;



// This is the new change made on 22nd
// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import PaymentStatusLoading from "../../../components/common/PaymentStatusLoading";
// import { api } from "../../../Config/Api";

// type PaymentOrderStatus = "PENDING" | "SUCCESS" | "FAILED";

// interface PaymentStatusResponse {
//   paymentLinkId: string;
//   paymentStatus: PaymentOrderStatus;
//   paymentOrderId: number;
// }

// const PaymentSuccessHandler: React.FC = () => {
//   const navigate = useNavigate();
//   const { orderId } = useParams<{ orderId: string }>(); // PaymentOrder.id from callback_url
//   const jwt = localStorage.getItem("jwt") || "";

//   const [status, setStatus] = useState<PaymentOrderStatus>("PENDING");
//   const [timedOut, setTimedOut] = useState(false); // true after 30s without final status

//   const pollRef = useRef<number | null>(null);
//   const timeoutRef = useRef<number | null>(null);
//   const startedAtRef = useRef<number>(Date.now());
//   const finishedRef = useRef<boolean>(false);

//   useEffect(() => {
//     startedAtRef.current = Date.now();
//     finishedRef.current = false;
//     setTimedOut(false);

//     const MIN_LOADER_MS = 5000;   // always show at least 5s for success/fail
//     const MAX_WAIT_MS = 30000;    // after 30s, stop and show fallback message
//     const POLL_EVERY_MS = 2000;

//     const clearAllTimers = () => {
//       if (pollRef.current !== null) {
//         window.clearInterval(pollRef.current);
//       }
//       if (timeoutRef.current !== null) {
//         window.clearTimeout(timeoutRef.current);
//       }
//       pollRef.current = null;
//       timeoutRef.current = null;
//     };

//     const navigateAfterMinDelay = (path: string) => {
//       if (finishedRef.current) return;
//       finishedRef.current = true;

//       const elapsed = Date.now() - startedAtRef.current;
//       const remaining = MIN_LOADER_MS - elapsed;
//       const delay = remaining > 0 ? remaining : 0;

//       timeoutRef.current = window.setTimeout(() => {
//         clearAllTimers();
//         navigate(path, { replace: true });
//       }, delay);
//     };

//     const handleTimeoutFallback = () => {
//       if (finishedRef.current) return;
//       finishedRef.current = true;

//       setTimedOut(true);

//       // stop polling but keep this timeout
//       if (pollRef.current !== null) {
//         window.clearInterval(pollRef.current);
//         pollRef.current = null;
//       }

//       // show the "we'll keep trying" message for a few seconds, then go to orders
//       timeoutRef.current = window.setTimeout(() => {
//         clearAllTimers();
//         navigate("/account/orders", { replace: true });
//       }, 5000); // show fallback text for ~5s
//     };

//     const fetchStatusOnce = async () => {
//       if (finishedRef.current) return;

//       const elapsed = Date.now() - startedAtRef.current;

//       // If we've already waited 30s and still no final status, show fallback
//       if (elapsed >= MAX_WAIT_MS && !finishedRef.current) {
//         handleTimeoutFallback();
//         return;
//       }

//       // If we somehow don't have orderId, treat as failure
//       if (!orderId) {
//         setStatus("FAILED");
//         navigateAfterMinDelay("/checkout/address");
//         return;
//       }

//       // If not logged in, bounce to login
//       if (!jwt) {
//         setStatus("FAILED");
//         navigateAfterMinDelay("/login");
//         return;
//       }

//       try {
//         const res = await api.get<PaymentStatusResponse>(
//           `/api/payment/order/${orderId}/status`,
//           {
//             headers: {
//               Authorization: `Bearer ${jwt}`,
//             },
//           }
//         );

//         console.log("🔍 Payment status response:", res.data);

//         const s: PaymentOrderStatus = res.data.paymentStatus || "PENDING";
//         setStatus(s);

//         if (s === "SUCCESS") {
//           // Success → go to existing Orders page
//           navigateAfterMinDelay("/account/orders");
//         } else if (s === "FAILED") {
//           // Failed → send user back to checkout (or cart)
//           navigateAfterMinDelay("/checkout/address");
//         }
//         // If still PENDING, just keep polling until MAX_WAIT_MS kicks in
//       } catch (e: any) {
//         console.error("Error while fetching payment status:", e);

//         const code = e?.response?.status;
//         if (code === 401 || code === 403) {
//           setStatus("FAILED");
//           navigateAfterMinDelay("/login");
//           return;
//         }

//         // For other errors, we keep polling until MAX_WAIT_MS
//       }
//     };

//     // First call immediately
//     fetchStatusOnce();
//     // Then keep polling
//     pollRef.current = window.setInterval(fetchStatusOnce, POLL_EVERY_MS);

//     return () => {
//       clearAllTimers();
//     };
//   }, [navigate, orderId, jwt]);

//   const title = timedOut
//     ? "Payment Confirmation Delayed"
//     : status === "PENDING"
//     ? "Confirming Payment"
//     : "Almost done";

//   const message = timedOut
//     ? "We have not received the payment confirmation from backend yet. We’ll keep trying in the background and update your order status."
//     : "Please wait while we are confirming your payment status.";

//   return <PaymentStatusLoading title={title} message={message} />;
// };

// export default PaymentSuccessHandler;



import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PaymentStatusLoading from "../../../components/common/PaymentStatusLoading";
import { api } from "../../../Config/Api";
import { trackEvent } from "../../../util/analytics";

type PaymentOrderStatus = "PENDING" | "SUCCESS" | "FAILED";

interface PaymentStatusResponse {
  paymentLinkId: string;
  paymentStatus: PaymentOrderStatus;
  paymentOrderId: number;
}

const PaymentSuccessHandler: React.FC = () => {
  const navigate = useNavigate();
  const { orderId } = useParams<{ orderId: string }>(); // PaymentOrder.id from callback_url
  const jwt = localStorage.getItem("jwt") || "";

  const [status, setStatus] = useState<PaymentOrderStatus>("PENDING");
  const [timedOut, setTimedOut] = useState(false); // true after 30s without final status

  const pollRef = useRef<number | null>(null);
  const timeoutRef = useRef<number | null>(null);
  const startedAtRef = useRef<number>(Date.now());
  const finishedRef = useRef<boolean>(false);

  useEffect(() => {
    if (orderId) {
      trackEvent("PAYMENT_SUCCESS_VIEW", {
        page: window.location.pathname,
        orderId: Number(orderId),
      });
    }
  }, [orderId]);

  useEffect(() => {
    startedAtRef.current = Date.now();
    finishedRef.current = false;
    setTimedOut(false);

    const MIN_LOADER_MS = 5000;   // always show at least 5s for success/fail
    const MAX_WAIT_MS = 30000;    // after 30s, stop and show fallback message
    const POLL_EVERY_MS = 2000;

    const clearAllTimers = () => {
      if (pollRef.current !== null) {
        window.clearInterval(pollRef.current);
      }
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
      pollRef.current = null;
      timeoutRef.current = null;
    };

    const navigateAfterMinDelay = (path: string) => {
      if (finishedRef.current) return;
      finishedRef.current = true;

      const elapsed = Date.now() - startedAtRef.current;
      const remaining = MIN_LOADER_MS - elapsed;
      const delay = remaining > 0 ? remaining : 0;

      timeoutRef.current = window.setTimeout(() => {
        clearAllTimers();
        navigate(path, { replace: true });
      }, delay);
    };

    const handleTimeoutFallback = () => {
      if (finishedRef.current) return;
      finishedRef.current = true;

      setTimedOut(true);

      // stop polling but keep this timeout
      if (pollRef.current !== null) {
        window.clearInterval(pollRef.current);
        pollRef.current = null;
      }

      // show the "we'll keep trying" message for a few seconds, then go to orders
      timeoutRef.current = window.setTimeout(() => {
        clearAllTimers();
        navigate("/account/orders", { replace: true });
      }, 5000); // show fallback text for ~5s
    };

    const fetchStatusOnce = async () => {
      if (finishedRef.current) return;

      const elapsed = Date.now() - startedAtRef.current;

      // If we've already waited 30s and still no final status, show fallback
      if (elapsed >= MAX_WAIT_MS && !finishedRef.current) {
        handleTimeoutFallback();
        return;
      }

      // If we somehow don't have orderId, treat as failure
      if (!orderId) {
        setStatus("FAILED");
        navigateAfterMinDelay("/checkout/address");
        return;
      }

      // If not logged in, bounce to login
      if (!jwt) {
        setStatus("FAILED");
        navigateAfterMinDelay("/login");
        return;
      }

      try {
        const res = await api.get<PaymentStatusResponse>(
          `/api/payment/order/${orderId}/status`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );

        console.log("🔍 Payment status response:", res.data);

        const s: PaymentOrderStatus = res.data.paymentStatus || "PENDING";
        setStatus(s);

        if (s === "SUCCESS") {
          // Success → go to existing Orders page
          navigateAfterMinDelay("/account/orders");
        } else if (s === "FAILED") {
          // Failed → send user back to checkout (or cart)
          navigateAfterMinDelay("/checkout/address");
        }
        // If still PENDING, just keep polling until MAX_WAIT_MS kicks in
      } catch (e: any) {
        console.error("Error while fetching payment status:", e);

        const code = e?.response?.status;
        if (code === 401 || code === 403) {
          setStatus("FAILED");
          navigateAfterMinDelay("/login");
          return;
        }

        // For other errors, we keep polling until MAX_WAIT_MS
      }
    };

    // First call immediately
    fetchStatusOnce();
    // Then keep polling
    pollRef.current = window.setInterval(fetchStatusOnce, POLL_EVERY_MS);

    return () => {
      clearAllTimers();
    };
  }, [navigate, orderId, jwt]);

  const title = timedOut
    ? "Payment Confirmation Delayed"
    : status === "PENDING"
    ? "Confirming Payment"
    : "Almost done";

  const message = timedOut
    ? "We have not received the payment confirmation from backend yet. We’ll keep trying in the background and update your order status."
    : "Please wait while we are confirming your payment status.";

  return <PaymentStatusLoading title={title} message={message} />;
};

export default PaymentSuccessHandler;